import { useEffect } from 'react';
import { router } from '../../core/router';
import { trackPageView } from '@tasama/utils';

/**
 * Fires a GA4 page_view event on every SPA navigation.
 *
 * Uses router.subscribe (React Router v7 low-level API) so it works outside
 * the RouterProvider tree and captures all navigations regardless of which
 * layout shell renders them.
 *
 * The initial page view is also tracked here — the index.html GA bootstrap
 * uses send_page_view: false, giving this hook full ownership of page_view.
 */
export function usePageTracking(): void {
  useEffect(() => {
    // Track the initial page load immediately
    trackPageView(window.location.pathname + window.location.search);

    // Track subsequent SPA navigations
    const unsubscribe = router.subscribe((state) => {
      if (state.navigation.state === 'idle') {
        trackPageView(state.location.pathname + state.location.search);
      }
    });

    return unsubscribe;
  }, []);
}
